import angular from 'angular';
import companyListComponent from './company-list.component';

export default angular.module('components.app.account.company-list', [])
  .component('companyList', companyListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/companies/company-list/company-list.module.js